import { Upload } from '@mui/icons-material';
import { Button, Divider, Grid, Paper, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useTilesQuery } from 'api/hooks/tiles';
import { CreateButton } from 'app/components';
import { IconDrawer } from 'app/components/IconDrawer';
import { TileDrawer } from 'app/components/TileDrawer';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { TileType } from '../../Dashboard/HomePage';
import { DashboardCard } from '../../Dashboard/HomePage/components/DashboardCard';
import { TileDrawerActions } from '../../Dashboard/HomePage/tileDrawerSlice';
import { DrawerMode } from '../../Dashboard/HomePage/types';
import { IconDrawerActions } from './iconDrawerSlice';

export const TileSettings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { data } = useTilesQuery({ params: { tileType: [TileType.SYSTEM, TileType.DEFAULT] } });
  usePageHeading({
    heading: t(translations.pages.tileSettings.title()),
    mobilePadding: false
  });

  // const handleSaveSystemTiles = async () => {};

  const systemTiles = data.filter(tile => tile.type === TileType.SYSTEM);
  const defaultTiles = data.filter(tile => tile.type === TileType.DEFAULT);

  const renderSystemTiles = () => {
    return (
      <Grid container spacing={4}>
        {systemTiles.map((item, index) => (
          <DashboardCard id={item.id.toString()} tile={item} key={item.id} isSettingsView />
        ))}
      </Grid>
    );
  };

  const renderDefaultTiles = () => {
    return (
      <Grid container spacing={4}>
        {defaultTiles.map((item, index) => (
          <DashboardCard id={item.id.toString()} tile={item} key={item.id} isSettingsView />
        ))}
      </Grid>
    );
  };

  return (
    <>
      <TileDrawer createType={TileType.SYSTEM} />
      <IconDrawer />
      <Grid
        container
        component={Paper}
        className="TileSettings"
        padding={'1em'}
        gap={2}
        flexDirection={'column'}
      >
        <Grid container justifyContent={'space-between'}>
          <CreateButton
            onClick={() => {
              dispatch(TileDrawerActions.setTile(undefined));
              dispatch(TileDrawerActions.setCurrentMode(DrawerMode.CREATE));
              dispatch(TileDrawerActions.open());
            }}
          />
          <Button
            variant="outlined"
            startIcon={<Upload />}
            onClick={() => {
              dispatch(IconDrawerActions.open());
            }}
          >
            Icon Upload
          </Button>
        </Grid>
        <Typography variant="h6" fontWeight={'bold'}>
          {t(translations.pages.tileSettings.systemTiles())}
        </Typography>
        {renderSystemTiles()}
        <Grid item xs>
          <Divider
            style={{ marginTop: 15, marginBottom: 15 }}
            sx={{
              borderWidth: 2,
              borderRadius: 10,
              borderColor: 'black',
              opacity: 0.3
            }}
          />
        </Grid>
        <Typography variant="h6" fontWeight={'bold'}>
          {t(translations.pages.tileSettings.defaultTiles())}
        </Typography>
        {renderDefaultTiles()}
        {/* <Grid container style={{ paddingTop: '1em' }} justifyContent={'flex-end'}>
          <SaveButton
            onClick={() => {
              handleSaveSystemTiles();
            }}
          />
        </Grid> */}
      </Grid>
    </>
  );
};
